import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Chat API
export const sendMessage = async (sessionId, message) => {
  const response = await api.post('/chat', { session_id: sessionId, message });
  return response.data;
};

export const getChatHistory = async (sessionId) => {
  const response = await api.get(`/chat/history/${sessionId}`);
  return response.data;
};

// Leads API
export const createLead = async (leadData) => {
  const response = await api.post('/leads', leadData);
  return response.data;
};

export const getLeads = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/leads', { params });
  return response.data;
};

export const updateLead = async (leadId, updates) => {
  const response = await api.patch(`/leads/${leadId}`, updates);
  return response.data;
};

// WhatsApp Lead API
export const sendLeadToWhatsApp = async (leadData) => {
  const response = await api.post('/whatsapp/send-lead', leadData);
  return response.data;
};

// Appointments API
export const createAppointment = async (appointmentData) => {
  const response = await api.post('/appointments', appointmentData);
  return response.data;
};

export const getAppointments = async (status = null) => {
  const params = status ? { status } : {};
  const response = await api.get('/appointments', { params });
  return response.data;
};

export const updateAppointment = async (appointmentId, updates) => {
  const response = await api.patch(`/appointments/${appointmentId}`, updates);
  return response.data;
};

// Newsletter API
export const subscribeNewsletter = async (email, name = null) => {
  const response = await api.post('/newsletter/subscribe', { email, name });
  return response.data;
};

export const getNewsletterSubscribers = async () => {
  const response = await api.get('/newsletter/subscribers');
  return response.data;
};

// Admin API
export const adminLogin = async (password) => {
  const response = await api.post('/admin/login', { password });
  return response.data;
};

export const getStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

export default api;
